<template>
  <div class="ap-search-field input-group clearfix" :class="{'input-group-sm': small}">
    <input type="text" class="form-control" :placeholder="placeholder" v-model="text" @input="change" @keyup.enter="submit">
    <div class="input-group-prepend">
      <a class="icon-search input-group-text" @click="submit">
        <span class="oi oi-magnifying-glass"></span>
      </a>
    </div>
  </div>
</template>
<script>
  //events: 
  //  submit 回车与点击查询
  export default {
    props: {
      placeholder: String,
      value: String,
      small: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        text: ''
      };
    },
    methods: {
      change() {
        this.$emit('update:value', this.text);
      },
      submit() {
        this.$emit('submit', this.text);
      }
    },
    watch: {
      value(v) {
        this.text = v;
      }
    }
  }
</script>
<style lang="less">
  @import url('../assets/less/vars.less');

  .ap-search-field {
    .input-group-prepend .input-group-text {
      padding-right: 0.75rem !important;
    }
    .icon-search {
      span {
        color: #888c9b;
      }
      &:hover {
        span {
          color: #333;
        }
      }
    }
  }
</style>